import React, { Component } from 'react';

import Blackout from '../wrappers/Blackout.jsx';

import './Footer.css';

class Footer extends Component {
  render() {
    const { viewport } = this.props;
    const year = new Date().getFullYear();
    const footerStyle = {
      height: viewport.height
    };

    return (
      <Blackout>
        <footer className="footer" style={footerStyle}>
          <div className="cell">
            <div className="grid">
              <div className="unit whole text-center">

                <div className="hr-container">
                    <hr className="left" />
                    {/* <hr /> */}
                </div>
                {/* <h1 className="mb0">The End.</h1> */}

                <p>&copy; Robert Phillips {year}</p>

              </div>
            </div>
          </div>
        </footer>
      </Blackout>
    );
  }
}

export default Footer;
